import styled, { css } from 'styled-components';

import { animated } from 'react-spring';

interface AlteredButtonProps {
  shouldAppear?: boolean;
}

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  z-index: 0;

  /* width: 360px; */
  padding: 10px;

  background: #fff;
  border: 3px solid #efefef;
  border-radius: 5px;

  > span {
    > p {
      width: 100%;
      text-align: left;
      color: #8a0002;
      font-family: 'Roboto Slab', serif;
      font-size: 16px;
      font-weight: 500;
      margin: 0 0 0 5px;
    }
    figure {
      width: 350px;
      margin: 0 0 0 5px;

      p {
        text-align: justify;
        font-size: 12px;
        color: #ff0000;
      }
    }
    & + span {
      margin: 15px 0 0 0;
    }
  }
`;

export const ApplicatorsInfo = styled.div``;

export const AlteredButton = styled.button<AlteredButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00802b;
  color: #efefef;
  padding: 10px 20px;
  width: 250px;
  border: 2px solid transparent;
  border-radius: 5px;

  font-size: 16px;
  font-family: 'Roboto Slab', serif;
  font-weight: 700;
  margin-bottom: 45px;

  opacity: 0;
  pointer-events: none;

  transition: all 0.35s ease;

  ${(props) =>
    props.shouldAppear &&
    css`
      opacity: 1;
      pointer-events: all;
    `}
`;

export const ButtonRemove = styled(animated.button)`
  border: 0;
  outline: none;
  background: transparent;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;

  color: #767676;
  font-size: 16px;
  font-family: 'Roboto Slab', serif;
  font-weight: bold;
  svg {
    margin-right: 5px;
    color: #c53030;
  }
`;
